import { render, staticRenderFns } from "./SetExpireDate.vue?vue&type=template&id=671766a0"
import script from "./SetExpireDate.vue?vue&type=script&lang=js"
export * from "./SetExpireDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports